<template lang="pug">
 #companion
    BLoading(:active="dailyContentLoading" :is-full-page="true")
    #companion-daily-content(v-if="!dailyContentLoading")
        .browse-button-container
            WtButton(isRouterLink :to="{ name: 'CompanionViewAll' , params:{ contentType: 'topics'}}") Browse all topics
        .edit-plan-container
            p.title Daily tasks
            WtButton.edit-button(isRouterLink color="primary" size="medium" :to="{ name: 'CompanionViewPlan' }") View plan
        .tasks-container
            p.custom-subtitle  Tasks
            .tasks(@mouseover="focusTasksContainer" tabindex="0" v-on="wheelListener")
               TaskCard(
                v-if="isExist('strategy')" 
                :id="strategy.Id" 
                :redirectTo="{name: 'CompanionDailyStrategy' , params:{ strategyId: strategy.Id }}" 
                :previewImage="strategy.PreviewImage" 
                :category="'Strategy'" 
                :title="strategy.Title" 
                :actionType="'Read'" 
                :duration="strategy.Duration" 
                :subTitle="strategy.Summary") 
               TaskCard(
                v-if="isExist('guide')" 
                :id="guide.GuidePartId" 
                :redirectTo="{ name: 'CompanionGuideDetail' , params:{ guideId: guide.GuidePartId }}" 
                :previewImage="guide.PreviewImage" 
                :category="'Guide'" 
                :title="guide.GuidePartTitle" 
                :actionType="'Listen'" 
                :duration="guide.Duration" 
                :subTitle="guide.Summary") 
        p.title Featured content
        PreviewCard( 
          v-if="isExist('workshop') && !isCoreTier" 
          :moduleType="'workshop'" 
          :moduleIcon="'companion/workshop_icon'" 
          :id="workshop.Id"
          :redirectTo="{ name: 'CompanionWorkshop' , params:{ workshopId: workshop.Id}}"
          :backgroundColor="'#' + workshop.BackgroundColor" 
          :previewImage="workshop.PreviewImage" 
          :duration="workshop.Length" 
          :title="workshop.Title" 
          :tag="workshop.StartDate"
          )
            template(v-slot:module-header)
              CompanionViewAllHeader(
                :moduleType="'Latest workshop'" 
                :moduleIcon="'companion/workshop_icon'" 
                :redirectToAll="{ name: 'CompanionViewAll' , params:{ contentType: 'workshops'}}"
              )
        PreviewCard( 
          v-if="isExist('article')" 
          :moduleType="'article'" 
          :moduleIcon="'companion/article_icon'" 
          :id="article.Id" :redirectTo="{ name: 'CompanionArticle' , params:{ articleId: article.Id}}" 
          :backgroundColor="'#' + article.BackgroundColor" 
          :previewImage="article.PreviewImage" 
          :duration="article.Duration" 
          :title="article.Title" 
          :tag="article.Tag" 
          :subTitle="article.PreviewText"
          )
            template(v-slot:module-header)
              CompanionViewAllHeader(
                :moduleType="'Latest article'" 
                :moduleIcon="'companion/article_icon'" 
                :redirectToAll="{ name: 'CompanionViewAll' , params:{ contentType: 'articles'}}"
              )
        PreviewCard( 
          v-if="isExist('topic')" 
          :moduleType="'topic'" 
          :moduleIcon="'companion/topic_icon'" 
          :id="topic.Id" :redirectTo="{ name: 'CompanionTopic' , params:{ topicId: topic.Id}}" 
          :backgroundColor="'#' + topic.BackgroundColor" 
          :previewImage="topic.PreviewImage" 
          :title="topic.Title" 
          :subTitle="topic.Summary"
          ) 
            template(v-slot:module-header)
              CompanionViewAllHeader(
                :moduleType="'Latest topic'" 
                :moduleIcon="'companion/topic_icon'" 
                :redirectToAll="{ name: 'CompanionViewAll' , params:{ contentType: 'topics'}}"
                )

</template>
<script>
import WtButton from "@@/WtButton/WtButton.vue";
import WtTitle from "@@/WtTitle/WtTitle.vue";
import WtTile from "@@/WtTile/WtTile";
import { mapActions, mapGetters } from "vuex";
import PreviewCard from "@@/Companion/PreviewCard";
import TaskCard from "@@/Companion/DailyContent/TaskCard";
import CompanionPostAssessmentModal from "@@/Companion/CompanionPostAssessmentModal";
import CompanionViewAllHeader from "@@/Companion/CompanionViewAllHeader";

export default {
  name: "CompanionDailyContent",
  components: {
    WtButton,
    WtTitle,
    WtTile,
    PreviewCard,
    TaskCard,
    CompanionPostAssessmentModal,
    CompanionViewAllHeader
  },
  data() {
    return {
      dailyContentLoading: false,
      content: [],
      workshop: []
    };
  },
  computed: {
    ...mapGetters("companion", ["assessmentState"]),
    ...mapGetters("program", ["isCoreTier"]),

    topic() {
      return (
        this.content?.Answer?.Strategy?.LatestTopic ??
        (this.content?.Answer?.Strategy?.Relatedtopics?.length > 0
          ? this.content?.Answer?.Strategy?.Relatedtopics[0]
          : {})
      );
    },
    guide() {
      return this.content?.Answer?.Strategy?.RelatedGuides[0] ?? {};
    },
    article() {
      return this.content?.Answer?.Strategy?.LatestArticle ?? {};
    },
    strategy() {
      return this.content?.Answer?.Strategy ?? {};
    },
    wheelListener() {
      if (window.innerWidth >= 768) {
        return {
          wheel: this.handleWheel
        };
      } else {
        return {};
      }
    }
  },
  async mounted() {
    try {
      this.dailyContentLoading = true;
      let [dailyContentResp, workShopResp] = await Promise.allSettled([
        this.fetchDailyContent(),
        this.fetchUserWorkShops()
      ]);
      if (dailyContentResp.status === "fulfilled") {
        this.content = dailyContentResp.value.data;
        if (
          !this.content?.Answer?.Strategy ||
          Object.keys(this.content.Answer.Strategy).length == 0
        ) {
          this.$router.push({ name: "Assessment" });
        } else {
          this.dailyContentLoading = false;

          const planStatus = this.assessmentState;

          if (planStatus === "created" || planStatus === "updated") {
            const modalInstance = this.$buefy.modal.open({
              component: CompanionPostAssessmentModal,
              props: {
                onRedirect: this.redirectToViewPlan,
                planStatus: planStatus
              },
              on: {
                close: () => modalInstance.close()
              },
              onCancel: () => {
                this.setAssessmentState({
                  assessmentState: "planCreated"
                });
              }
            });
          }
        }
      } else if (dailyContentResp.status === "rejected") {
        this.$router.push({ name: "Assessment" });
        this.dailyContentLoading = false;
      }

      if (workShopResp.status === "fulfilled") {
        let futureWorkshops = [];
        let workshops = workShopResp.value.data;
        //find workshops that are future/upcoming
        workshops.forEach(workshop => {
          let start = new Date(workshop.StartDate);
          let today = new Date();
          let days = this.moment(start).diff(this.moment(today), "days");
          if (start > today) {
            workshop.daysUntilStart = days;
            futureWorkshops.push(workshop);
          }
        });
        //make featured workshop the one that is nearest in the future
        this.workshop = futureWorkshops.sort(
          (a, b) => a.daysUntilStart - b.daysUntilStart
        )[0];
      } else {
        this.workshop = {};
      }
    } catch (error) {
      this.dailyContentLoading = false;
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: error.message
      });
    }
  },
  methods: {
    ...mapActions("companion", [
      "fetchDailyContent",
      "fetchUserWorkShops",
      "setAssessmentState"
    ]),
    ...mapActions(["snackBar"]),
    isExist(type) {
      switch (type) {
        case "workshop":
          return this.workshop && Object.keys(this.workshop).length > 0;
        case "guide":
          return this.guide && Object.keys(this.guide).length > 0;
        case "topic":
          return this.topic && Object.keys(this.topic).length > 0;
        case "article":
          return this.article && Object.keys(this.article).length > 0;
        case "strategy":
          return this.strategy && Object.keys(this.strategy).length > 0;
        default:
          return false;
      }
    },
    focusTasksContainer() {
      const slider = document.querySelector(".tasks");
      slider.focus();
    },

    redirectToViewPlan() {
      this.$router.push({ name: "CompanionViewPlan" });

      this.setAssessmentState({
        assessmentState: "planCreated"
      });
    },

    handleWheel(event) {
      const deltaY = event.deltaY;
      const absDeltaY = Math.abs(deltaY);
      const isExternalMouse = absDeltaY > 2;

      if (isExternalMouse) {
        const scrollContainer = document.querySelector(".tasks");
        event.preventDefault();

        const scrollSpeed = 10;
        const newScrollLeft = scrollContainer.scrollLeft + deltaY * scrollSpeed;
        if (
          newScrollLeft > -10 &&
          newScrollLeft <=
            scrollContainer.scrollWidth - scrollContainer.clientWidth + 10
        ) {
          scrollContainer.scrollLeft = newScrollLeft;
        } else if (newScrollLeft < 0) {
          scrollContainer.scrollLeft = 0;
        } else if (
          newScrollLeft >
          scrollContainer.scrollWidth - scrollContainer.clientWidth
        ) {
          scrollContainer.scrollLeft =
            scrollContainer.scrollWidth - scrollContainer.clientWidth;
        }
      }
    }
  }
};
</script>
<style scoped>
#companion-daily-content {
  border-radius: 16px;
  font-weight: 60 !important;
  line-height: 30px;
  font-size: 1.3rem;
  min-height: 100%;
  padding: 0px;
  margin: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 60%;
  gap: 32px;
}

.tasks-container {
  display: flex;
  width: 670px;
  height: 280px;
  padding: 16px 24px 24px 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  flex-shrink: 0;
  border-radius: var(--Radius-xxLarge, 16px);
  border: 1px solid #d9dbe0;
  background: #fff;
}

.title {
  color: var(--Text-General-Primary, #1b1d20);
  font-family: Manrope;
  font-size: 30px;
  font-style: normal;
  font-weight: 700;
  line-height: 32px;
  margin: 0rem;
  width: 670px;
}

.custom-subtitle {
  color: #1b1d20;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 125% */
}

.edit-plan-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 670px;
}

.edit-button {
  display: inline-flex;
  padding: 6px 8px;
  justify-content: center;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  color: #ffffff;
  text-align: center;
  font-family: Manrope;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 16px;
}

.browse-button-container {
  display: flex;
  width: 670px;
  height: 45px;
}
.browse-button-container > .button {
  padding: 12px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 12px;
  background: #2972f0;
  width: 670px;
  letter-spacing: 0.18px;
}

.tasks {
  display: flex;
  flex-direction: row;
  display: flex;
  align-items: flex-start;
  gap: 8px;
  overflow-x: auto;
  overflow-y: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  width: 100%;
}

.tasks::-webkit-scrollbar {
  display: none;
}

.tasks:focus {
  outline: none;
}

@media screen and (max-width: 768px) {
  #companion-daily-content {
    max-width: 80%;
  }
  .tasks-container {
    width: 100%;
    height: min-content;
  }
  .tasks {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
  .title {
    width: 100%;
  }
  .edit-plan-container {
    width: 100%;
  }
  .browse-button-container {
    width: 100%;
  }
  .browse-button-container > .button {
    width: 100%;
  }
}

@media screen and (max-width: 480px) {
  #companion-daily-content {
    max-width: 100%;
    .tasks-container {
      border: none;
    }
  }
}
</style>
